<div
    class="agpr-colorGradientPicker"
    [class.agpr-colorGradientPicker--disabled]="disabled"
    [class.agpr-colorGradientPicker--dragging]="colorDragging || hueDragging"
>
    <div class="agpr-colorGradientPicker-previewSwatch" [style.background-color]="value.hex">
    </div>

    <div
        [id]="id + '_graient'"
        class="agpr-colorGradientPicker-content agpr-colorGradientPicker-foucsable"
        role="button"
        tabindex="0"
        (keydown)="onColorKeydown($event)">
        <!-- 2D Color Selector (Saturation/Brightness) -->
        <div #colorSelector class="agpr-colorGradientPicker-colorSelector" (mousedown)="onColorMousedown($event)">
            <div class="agpr-colorGradientPicker-colorGradient">
                <div #colorHandle class="agpr-colorGradientPicker-colorHandle"></div>
            </div>
        </div>
    </div>

    <!-- Vertical Hue Slider -->
    <div
        #hueSlider
        [id]="id + '_graient_hueSlider'"
        class="agpr-colorGradientPicker-hueSlider agpr-colorGradientPicker-foucsable"
        (mousedown)="onHueMousedown($event)"
        (keydown)="onHueKeydown($event)"
        role="button"
        tabindex="0">
        <div #hueHandle class="agpr-colorGradientPicker-hueHandle"></div>
    </div>
</div>
